import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import firebase from "firebase/app";
import "firebase/firestore";

Vue.component("loading", Loading);

const firebaseConfig = {
  apiKey: "AIzaSyCR8rMTUSsixYYbgPenCfnxhYCw8PxNvA4",
  authDomain: "bgplatformu-9d0d3.firebaseapp.com",
  databaseURL: "https://bgplatformu-9d0d3.firebaseio.com",
  projectId: "bgplatformu-9d0d3",
  storageBucket: "bgplatformu-9d0d3.appspot.com",
  messagingSenderId: "476521295872",
  appId: "1:476521295872:web:99a15458b45758cb87a8e5"
};

firebase.initializeApp(firebaseConfig);

export const fs = firebase.firestore();
export const firebaseService = firebase;

Vue.config.productionTip = false;
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
